import tw, { styled } from 'twin.macro';
import FormButton from '../components/FormButton/FormButton';

export const FormFooter = styled.div`
  ${tw`flex flex-col`}
  ${tw`gap-2`}
`;

export const StyledForm = styled.form`
  ${tw`flex flex-col gap-2`}
`;

export const SubmitButton = styled(FormButton)`
  ${tw`block`}
  ${tw`w-full`}
  ${tw`text-center`}
  ${tw`after:[content: '']`}
`;
